import { useEffect, useState } from 'react';

import cogoToast from 'cogo-toast';
import DataTable from 'react-data-table-component';
import { Row, Col, Button, Modal, ModalBody, CardFooter, Spinner } from 'reactstrap';

import { baseUrl, indianProjectsBaseURL } from '../../../../../../../../../Config';
import { TablePagination } from '../../../../../../../../../Common';
import { Constant } from '../../../../../../../../../Helpers/constant';
import { hasPermission } from '../../../../../../../../../Helpers/Helpers';
import { PermissionConstants } from '../../../../../../../../../Helpers/Constants/permissions';

const ProgramPricingDetails = ({
  appliedFilters,
  pricingData,
  reconPreviewData,
  onClose,
  onUpload,
  onFilter,
  currentPageNumber,
  currentSelectedDetails,
  onChangePage,
}) => {
  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [previewData, setPreviewData] = useState([]);
  const [isDownloadLoading, setIsDownloadLoading] = useState(false);

  // console.log('welcommmme', pricingData, reconPreviewData);

  /* ---------------------------- DYNAMIC DATA HANDLER ---------------------------- */
  useEffect(() => {
    if (reconPreviewData?.results?.length > 0) {
      const rowData = reconPreviewData?.results?.map(rowData => {
        let excelRowData = {};
        Object.entries(rowData)?.forEach(([key, value], index) => {
          excelRowData = {
            ...excelRowData,
            [key]: rowData?.[key]?.['value'],
          };
        });

        return { ...excelRowData, originalData: rowData };
      });

      setPreviewData(rowData);
    } else {
      setPreviewData([]);
    }
  }, [reconPreviewData]);

  /* ---------------------------- FIND COLUMN HANDLER ---------------------------- */
  const findColumnsHandler = () => {
    if (reconPreviewData?.results?.length > 0) {
      const colData = Object.entries(reconPreviewData?.results?.[0])?.map(([key, value], index) => {
        return {
          name: `${value?.['headerName']}`,
          width: '200px',
          wrap: true,
          selector: row => row?.[key],
        };
      });

      return colData;
    } else {
      return [];
    }
  };

  /* ---------------------------- DOWNLOAD FILE HANDLER ---------------------------- */
  const downloadFile = () => {
    setIsDownloadLoading(true);

    const params = {
      ...(pricingData?.reconType?.code === 1 && { partnerId: pricingData?.partner?.id }),
      ...(pricingData?.reconType?.code === 2 && { projectId: pricingData?.program?.id }),
    };

    const url = new URL(`${indianProjectsBaseURL}/admin/download-excel`);
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: Constant?.CLIENT_TOKEN,
        'Project-Code': 'ADMIN_ACCESS',
      },
      body: JSON.stringify({
        projectId: `${pricingData?.projectId ?? ''}`,
        benefitGroupId: `${pricingData?.benefitGroups?.id ?? ''}`,
        categoryId: `${pricingData?.category?.id ?? ''}`,
        fileConfigId: `${pricingData?.configId ?? ''}`,
        month: `${pricingData?.month}`,
        year: `${pricingData?.year}`,
        reconType: pricingData?.reconType?.code,
      }),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.blob();
      })
      .then(blob => {
        setIsDownloadLoading(false);
        const link = document.createElement('a');
        const fileName = 'file.xlsx';
        link.setAttribute('download', fileName);
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch(error => {
        setIsDownloadLoading(false);
        cogoToast.error('Something went wrong');
      });
  };

  return (
    <Modal isOpen={true} centered size="lg">
      <div className="modal-header p-3 bg-soft-secondary">
        <h5 className="modal-title">Recon Details</h5>
        <Button
          type="button"
          onClick={() => {
            onClose();
          }}
          className="btn-close btn-light"
          aria-label="Close"
        ></Button>
      </div>

      <ModalBody>
        <Row>
          <Col md={12} className="mb-2">
            <h5>
              {`${pricingData?.category?.name}`} {` >> ${pricingData?.clientOrVendor}`} {`${pricingData?.month}`} {`-${pricingData?.year}`}
            </h5>
          </Col>

          <>
            <Col md={12}>
              <p className="fw-semibold">Filter by Recon Status -</p>
            </Col>

            <Col md={12} className="mb-2">
              {[
                { id: `1`, name: `All records`, value: `` },
                { id: `2`, name: `Ok(All)`, value: `1` },
                { id: `3`, name: `Pending(All)`, value: `2` },
              ]?.map((filter, index) => (
                <button
                  key={index}
                  className={`btn btn-sm rounded-pill mb-2 me-2 ${appliedFilters?.id === filter?.id ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => onFilter(filter)}
                >
                  <span className="d-flex align-items-center">
                    <span className="flex-grow-1">{filter?.name}</span>
                  </span>
                </button>
              ))}
            </Col>
          </>
          {/* )} */}

          <Col md={12}>
            <DataTable
              columns={findColumnsHandler()}
              data={previewData}
              customStyles={{
                table: {
                  style: {
                    border: '1px solid #afafaf',
                    maxHeight: '350px',
                    overflowY: 'auto',
                  },
                },
                headRow: {
                  style: {
                    borderBottom: '1px solid #ddd', // Header bottom border
                    backgroundColor: '#f9fafb',
                    fontWeight: '600',
                  },
                },
                cells: {
                  style: {
                    border: '0.5px solid #ddd', // Cell borders
                    borderBottom: '0px solid #ddd',
                  },
                },
              }}
            />
          </Col>

          {reconPreviewData?.results?.length > 0 && (
            <Col md={12} className="mt-3 d-flex justify-content-between align-items-center">
              <span>
                Showing <b>{currentPageNumber * Constant?.TABLE_PAGE_SIZE + 1}</b> to&nbsp;
                <b>{currentPageNumber * Constant?.TABLE_PAGE_SIZE + reconPreviewData?.results?.length}</b> of <b>{reconPreviewData?.count}</b> records
              </span>
              <div className="d-flex justify-content-end">
                <TablePagination totalData={reconPreviewData?.count} currentPage={currentPageNumber} onPageChangeHandler={onChangePage} />
              </div>
            </Col>
          )}
        </Row>
      </ModalBody>

      <CardFooter className="pb-0">
        <div className="modal-footer mx-auto d-flex gap-2">
          {hasPermission(PermissionConstants?.ALL_PERMISSIONS?.UPLOAD_FILE_WITH_AUTH_BOOKING_RECON_GM_REPORT) && (
            <button
              type="button"
              className="btn btn-outline-primary btn-md"
              onClick={() => {
                onUpload();
              }}
            >
              <i className="ri-upload-2-line align-middle"></i>&nbsp; Upload
            </button>
          )}

          {reconPreviewData?.results?.length > 0 && (
            <>
              {hasPermission(PermissionConstants?.ALL_PERMISSIONS?.DOWNLOAD_FILE_BOOKING_RECON_GM_REPORT) && isDownloadLoading ? (
                <Button color="primary" className="btn-load mx-1" outline>
                  <span className="d-flex align-items-center">
                    <Spinner size="sm" className="flex-shrink-0">
                      Loading...
                    </Spinner>
                    <span className="flex-grow-1 ms-2">Loading...</span>
                  </span>
                </Button>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary btn-md mx-1"
                  onClick={() => {
                    downloadFile();
                  }}
                >
                  <i className="ri-download-cloud-line align-middle"></i>&nbsp; Download
                </button>
              )}
            </>
          )}
        </div>
      </CardFooter>
    </Modal>
  );
};

export default ProgramPricingDetails;
